import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Pane, Heading, defaultTheme, majorScale } from 'evergreen-ui'
import SourceIcon from './Icons/SourceIcon'
import DestinationIcon from './Icons/DestinationIcon'
import WarehouseIcon from './Icons/WarehouseIcon'
import CatalogIcon from './Icons/CatalogIcon'

const toTitle = name => {
  if (name !== 'catalog') {
    return `Your ${name}s`
  }
  return name
}

const categoryStyle = {
  borderBottom: 'muted',
  paddingX: majorScale(2),
  paddingY: majorScale(1),
  display: 'flex',
  alignItems: 'center'
}

const Category = ({ name, hasTopBorder, children }) => (
  <Fragment>
    <Pane {...categoryStyle} borderTop={hasTopBorder ? 'muted' : undefined}>
      {name === 'source' && <SourceIcon />}
      {name === 'destination' && <DestinationIcon />}
      {name === 'warehouse' && <WarehouseIcon />}
      {name === 'catalog' && <CatalogIcon />}

      <Heading
        textTransform="uppercase"
        color={defaultTheme.palette.green.base}
        size={300}
        marginLeft={majorScale(1)}
      >
        {toTitle(name)}
      </Heading>
    </Pane>

    <Pane display="flex" flexDirection="column">
      {children}
    </Pane>
  </Fragment>
)

Category.propTypes = {
  name: PropTypes.string.isRequired,
  hasTopBorder: PropTypes.bool,
  children: PropTypes.node
}

Category.defaultProps = {
  hasTopBorder: true
}

export default Category
